module.exports = {
	"articleTitle1": "Lila Kalick: So what's the deal with the Jamaican Jerk Pit?",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Jamaican Jerk Pit",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/festivals-no-longer-just-holidays",
	"articleSnippet1": "Nov 3, 2010 ... You're curious. I'm curious. We're all curious. What is the deal with the Jamaican \nJerk Pit on N. Thayer Street across from Hill Auditorium?",
	"articleSnippet2": "BY PUNIT MATTOO AND KIMBERLY CHOU Published November 16, 2006. \nPunit Mattoo: Jamaican Jerk Pit might be the most distinct dining place in Ann \nArbor ...",
	"foodRecommendations": [
		{
			"text": "Don't be deceived if it looks empty inside because a majority of the seats are downstairs.",
			"person": "Andrew Fridenberg"
		},
		{
			"text": "The medium spice is actually pretty hot, so I would recommend the mild.",
			"peson": "Andrew Fridenberg"
		}
	],
	"articleTitle2": "Festivals - ",
	"address": "314 S Thayer St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279046,
		"lng": -83.7398
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/jamaicanjerkpit.json
// module id = 898
// module chunks = 0